import { createApiRequestType, strictObjectAccess } from '@ackee/redux-utils';
import { EntityKey } from 'constants/index';

const apiRequest = createApiRequestType({ modulePrefix: EntityKey.DOCUMENT_OTHER });

export const fetchOtherDocumentsTypes = strictObjectAccess({ ...apiRequest({ typePrefix: 'FETCH_OTHER_DOCUMENTS_' }) });
